var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.952 3.048a3.58 3.58 0 00-5.06 0L3.94 15a3.1 3.1 0 00-.825 1.476L2.02 21.078a.75.75 0 00.904.903l4.601-1.096a3.1 3.1 0 001.477-.825l11.95-11.95a3.58 3.58 0 000-5.06m-4 1.06a2.08 2.08 0 012.94 2.94L19 7.939 16.06 5l.892-.89zM15 6.062L17.94 9l-10 10c-.21.21-.474.357-.763.426l-3.416.814.813-3.416c.07-.29.217-.554.427-.764l10-9.998z",
    fill: "#333230"
  })));
}
export default SvgEditNew;